/** Backend notification type IDs. */
export const NotificationTypeId = {
  NewMessage: 1,
  PriceDrop: 2,
  ListingApproved: 3,
  ListingRejected: 4,
  SupportTicketResolved: 5,
  AccountWarning: 6,
  RuleUpdate: 7,
} as const;

export type NotificationTypeIdValue =
  (typeof NotificationTypeId)[keyof typeof NotificationTypeId];

interface NotificationMeta {
  icon: string;
  bgColor: string;
  label: string;
}

const META_MAP: Record<number, NotificationMeta> = {
  [NotificationTypeId.NewMessage]: {
    icon: 'envelope',
    bgColor: 'bg-info',
    label: 'Mesajlar',
  },
  [NotificationTypeId.PriceDrop]: {
    icon: 'tag',
    bgColor: 'bg-success',
    label: 'Fiyat Değişimleri',
  },
  [NotificationTypeId.ListingApproved]: {
    icon: 'check-circle',
    bgColor: 'bg-success',
    label: 'Onaylanan İlanlar',
  },
  [NotificationTypeId.ListingRejected]: {
    icon: 'times-circle',
    bgColor: 'bg-danger',
    label: 'Reddedilen İlanlar',
  },
  [NotificationTypeId.SupportTicketResolved]: {
    icon: 'headset',
    bgColor: 'bg-info',
    label: 'Destek Sonuçları',
  },
  [NotificationTypeId.AccountWarning]: {
    icon: 'exclamation-triangle',
    bgColor: 'bg-warning',
    label: 'Uyarılar',
  },
  [NotificationTypeId.RuleUpdate]: {
    icon: 'file-contract',
    bgColor: 'bg-secondary',
    label: 'Kural Güncellemeleri',
  },
};

const DEFAULT_META: NotificationMeta = {
  icon: 'bell',
  bgColor: 'bg-info',
  label: 'Bildirim',
};

export function getNotificationMeta(typeId: number): NotificationMeta {
  return META_MAP[typeId] ?? DEFAULT_META;
}
